import { OutOfStateContactInfo } from '../../cards/contact-info-short/out-of-state';
import EarlyKickOut from '../../cards/early-kick-out';
import { AffordabilityState, PreapprovalState, PurchaseState, RefiState } from '../../cards/state';
import { VeteransBenefits } from '../../cards/veterans-benefits';
import { Branch, Card, End } from '../../components/deck';

export const permittedStates = [
  'CA',
  'CO',
  'CT',
  'FL',
  'GA',
  'MA',
  'ME',
  'MI',
  'NH',
  'PA',
  'RI',
  'TN',
  'TX'
]; // alphabetical order

const VeteransVerificationBranch = () =>
  Branch(
    {
      NotEligible: Card(OutOfStateContactInfo, Card(EarlyKickOut, End()))
    },
    ({ model }) => {
      // Allow Veterans through from any state
      const veteranStatus = model.getIn(['borrower', 'vaQualification']);
      const coborrowerVeteranStatus = model.getIn(['coborrower', 'vaQualification']);
      return (veteranStatus && veteranStatus !== 'Ineligible') ||
        (coborrowerVeteranStatus && coborrowerVeteranStatus !== 'Ineligible')
        ? null
        : 'NotEligible';
    }
  );

const inState = (model, target) => {
  return (
    permittedStates.includes(model.getIn(['loan', target])) || model.getIn(['loan', 'advisor'])
  );
};

const VerificationVeteranCheckBranch = (continuation, target) =>
  Branch(
    {
      OutOfStateVeteranCheck: Card(VeteransBenefits, VeteransVerificationBranch())
    },
    ({ model }) => {
      return inState(model, target) ? null : 'OutOfStateVeteranCheck';
    },
    continuation
  );

const VerificationBranch = (continuation, target) =>
  Branch(
    {
      OutOfState: Card(OutOfStateContactInfo, Card(EarlyKickOut, End()))
    },
    ({ model }) => {
      return inState(model, target) ? null : 'OutOfState';
    },
    continuation
  );

export const PreapprovalStateVerification = (continuation) =>
  Card(PreapprovalState, VerificationBranch(continuation, 'preapprovalState'));

export const PurchaseStateVerification = (continuation) =>
  Card(PurchaseState, VerificationVeteranCheckBranch(continuation, 'loanState'));

export const RefiStateVerification = (continuation) =>
  Card(RefiState, VerificationVeteranCheckBranch(continuation, 'loanState'));

export const AffordabilityStateVerification = (continuation) =>
  Card(AffordabilityState, VerificationBranch(continuation, 'loanState'));



// WEBPACK FOOTER //
// ./src/decks/branches/state-verification.js